import axios from 'axios'

import { getAccessToken } from '@/features/auth/utils/tokenStorage'
import { env } from '@/shared/config/env'
import { getErrorMessage } from '@/shared/lib/errorMessage'

export const apiClient = axios.create({
  baseURL: env.apiBaseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken()

  config.headers = config.headers || {}
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (tz) {
      config.headers['x-timezone'] = tz
    }
  } catch {
    config.headers['x-timezone'] = 'Asia/Kolkata'
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = getErrorMessage(
      error,
      'Something went wrong. Please try again.',
    )

    error.message = message
    error.status = error.response?.status
    error.data = error.response?.data

    return Promise.reject(error)
  },
)
